// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"9d6f46c3","175":"b7beeb63","184":"52c77b95","243":"0957f530","393":"b37b8424","624":"96deb1a3","712":"3bf57da9","745":"03e73099","921":"fdfd30e7"}[chunkId] + ".chunk.js";
};